"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useLocalTheme = _interopRequireDefault(require("../../../hooks/useLocalTheme"));
var _services = require("../../../services");
var _useRecommendationBroadbands = require("../../../hooks/recommendation/useRecommendationBroadbands");
var _constants = require("../../../utils/constants");
var _useConfig = _interopRequireDefault(require("../../../hooks/useConfig"));
var _utils = require("../../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Container = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    & [class*='ContainerWithLabelstyle__LabelContainer'] {
      background-color: ${props === null || props === void 0 ? void 0 : props.bgColor};
      display: flex;
      justify-content: flex-start;
      & p {
        color: ${props === null || props === void 0 ? void 0 : props.color};
        font-weight: 400;
        font-size: ${props === null || props === void 0 ? void 0 : props.tipFontSize};
      }
    }
    & [class*='Interactionstyle__BlankInteraction']::after {
      content: ' ';
      border-color: ${props === null || props === void 0 ? void 0 : props.borderColor};
    }
  `);
const StyledHeader = _styledComponents.default.div`
  color: #0d0d0d !important;
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;

  ${_r10SourceLibrary.Mixins.respondTo.md(` font-size: 30px; line-height: 37.5px`)}
`;
const StyledColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  margin-bottom: 0 !important;
  @media (max-width: 768px) {
    margin-left: 12px;
    margin-right: 12px;
  }
  & button {
    font-size: ${prop => prop.actionButtonFontSize}px;
    line-height: 24px;
    ${_r10SourceLibrary.Mixins.respondTo.md(` font-size: 20px;`)}
  }
`;
const StyledSpan = _styledComponents.default.span`
  color: #0d0d0d !important;
  font-size: 18px;
  line-height: normal;
  font-weight: 400;

  ${_r10SourceLibrary.Mixins.respondTo.md(` font-size: 20px;`)}
`;
const StyledParagraph = _styledComponents.default.p`
  color: #ffffff !important;
  font-size: 16px;
  line-height: normal;
  font-weight: 400;
  text-align: center;
  ${_r10SourceLibrary.Mixins.respondTo.md(` font-size: 20px;`)}
`;
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  margin-bottom: 10px !important;
  & h3 {
    line-height: 30px;
    ${_r10SourceLibrary.Mixins.respondTo.md(`font-size: 30px; line-height: 37.5px;`)}
  }
`;
const StyledDisclaimer = _styledComponents.default.p`
  margin-top: 10px;
  line-height: 24px;
  font-size: 16px;
`;
const RecommendationBroadbandContainer = () => {
  var _selectedBroadband$ch, _selectedBroadband$ch2, _selectedBroadband$ch3, _selectedBroadband$ch4;
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    selectedBroadband
  } = (0, _useRecommendationBroadbands.useRecommendationBroadbands)() || {};
  const {
    productDescription,
    productName
  } = (selectedBroadband === null || selectedBroadband === void 0 ? void 0 : selectedBroadband.selectedVariant) || {};
  const redirectionLinkParam = (0, _useConfig.default)('redirectionLinkParam', '');
  const openDeepLinksNewTab = (0, _useConfig.default)('devSettings.openDeepLinksNewTab', '');
  const redirectionLink = selectedBroadband === null || selectedBroadband === void 0 ? void 0 : (_selectedBroadband$ch = selectedBroadband.characteristics) === null || _selectedBroadband$ch === void 0 ? void 0 : (_selectedBroadband$ch2 = _selectedBroadband$ch.find(char => char.id === _constants.CHARACTERISTIC_IDS.DETAILS_LINK)) === null || _selectedBroadband$ch2 === void 0 ? void 0 : _selectedBroadband$ch2.valueText;
  const technology = selectedBroadband === null || selectedBroadband === void 0 ? void 0 : (_selectedBroadband$ch3 = selectedBroadband.characteristics) === null || _selectedBroadband$ch3 === void 0 ? void 0 : (_selectedBroadband$ch4 = _selectedBroadband$ch3.find(char => char.id === _constants.CHARACTERISTIC.TECHNOLOGY)) === null || _selectedBroadband$ch4 === void 0 ? void 0 : _selectedBroadband$ch4.valueText;
  const DISCLAIMER_MAP = {
    Cable: _services.Services.locale.localeString('Recommendation.Container.Disclaimer.KIP'),
    Fiber_VFDE: _services.Services.locale.localeString('Recommendation.Container.Disclaimer.Fiber')
  };
  const disclaimer = DISCLAIMER_MAP[technology];
  const redirectionLinkWithParam = redirectionLink + redirectionLinkParam;
  const containerWithLabelStyle = (0, _useLocalTheme.default)(`recommendation.containerWithLabelStyle.label`, null);
  const paddingLevelOnMobile = (0, _useLocalTheme.default)(`recommendation.containerWithLabelStyle.paddingLevelOnMobile`, 0);
  const onRedirectToLink = redirectionLinkWithParam => {
    window.open(redirectionLinkWithParam, openDeepLinksNewTab ? '_blank' : '_self');
  };
  const actionButtonFontSize = (0, _useLocalTheme.default)('actionButtonFontSize');
  const renderRedirectionButton = () => redirectionLink && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'center',
    noMargin: true
  }, /*#__PURE__*/_react.default.createElement(StyledColumn, {
    col: 12,
    actionButtonFontSize: actionButtonFontSize
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    width: "full",
    text: _services.Services.locale.localeString('Recommendation.Container.ButtonText'),
    onClick: () => onRedirectToLink(redirectionLinkWithParam),
    dataAttributes: {
      'data-testid': 'btn-redirection-link'
    }
  })));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 7,
    colMd: 12,
    noMargin: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 3,
    level: 3,
    weight: 3,
    justify: 'center',
    text: _services.Services.locale.localeString('Recommendation.Container.Title'),
    id: "page-title"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    colMd: 12
  }, /*#__PURE__*/_react.default.createElement(StyledParagraph, {
    id: "page-subtitle"
  }, _services.Services.locale.localeString('Recommendation.Container.Subtitle')))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 2
    }
  }, /*#__PURE__*/_react.default.createElement(Container, containerWithLabelStyle, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, _extends({
    label: _services.Services.locale.localeString('Recommendation.Container.Label'),
    showOuterTopPadding: true
  }, breakpoints.sm && {
    paddingLevel: paddingLevelOnMobile
  }, {
    id: "container-testid"
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'left'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(StyledHeader, {
    "data-testid": "header-title"
  }, productName))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: 'left'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(StyledSpan, {
    dangerouslySetInnerHTML: {
      __html: (0, _utils.decodeHtmlEntities)(productDescription)
    }
  }), disclaimer && /*#__PURE__*/_react.default.createElement(StyledDisclaimer, {
    id: "disclaimer-testid"
  }, disclaimer))), renderRedirectionButton()))))));
};
var _default = RecommendationBroadbandContainer;
exports.default = _default;